import {actionCreatorFactory} from 'typescript-fsa';

export type ImpersonateResponse = {
	jwt: string;
}

const impersonate = actionCreatorFactory('IMPERSONATION');

export const ImpersonateAgent = impersonate.async<string, ImpersonateResponse>('IMPERSONATE_AGENT');
export const RestoreImpersonation = impersonate('RESTORE_IMPERSONATION');